import { pipe } from 'fp-ts/function'
import { decodeJson, del, get, post, put } from 'lib/request'

import {
  TAPIKey,
  TCLIReleaseDate,
  TGenerateAPIKeyResponse,
  TUserSettings,
  UserSettings,
} from '.'

export const generateAPIKey = async () => {
  return pipe(
    await post('api/users/me/api_key', {}),
    decodeJson(TGenerateAPIKeyResponse),
  )
}

export const getAPIKey = async () => {
  return pipe(await get('api/users/me/api_key', {}), decodeJson(TAPIKey))
}

export const deleteAPIKey = async () => {
  return await del('api/users/me/api_key', {})
}

export const getCLIReleaseDate = async () => {
  return pipe(await get('api/cli/release', {}), decodeJson(TCLIReleaseDate))
}

export const getUserSettings = async () => {
  return pipe(await get('api/users/me/settings', {}), decodeJson(TUserSettings))
}

export type UpdateUserSettingsInput = Partial<UserSettings>

export const updateUserSettings = async (input: UpdateUserSettingsInput) => {
  const response = await put('api/users/me/settings', { body: input })

  if (response.status === 204) {
    return input as UserSettings
  }

  return pipe(response, decodeJson(TUserSettings))
}
